<template>
    <v-card flat class="score-trans ml-1 mr-1" :height="getChartHeight()">
        <v-container fluid>
            <v-row dense>
                <v-col cols="12">
                    <v-card flat class="score-trans">
                        <h3>Arrivals/year</h3>
                        <h5>Number of arrivals for this year and last year</h5>
                    </v-card>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-card flat fluid :height="getChartHeight() - chart_correction" class="score-trans">
                        <canvas id="arrivals-year" height="300" style="width:100%;"></canvas>
                    </v-card>    
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

    import mxchart from '@/components/js/charts/arrivalsyear_chart_V2';
    import mxscreensize from '@/components/js/screensize';

    import { Chart, registerables } from 'chart.js'
    Chart.register(...registerables)    


    export default {
        props: {
            height_correction: Number,
            chart_correction: Number,
        },           
        data() {
            return {
                arrivals: [],
                arrivalsPrev: [], 
                chart: null,
            }
        },
        created(){ // set up event bus listener here on created event
            this.load('load');
        },                  
        mixins:[mxchart, mxscreensize],
        methods:{
            getChartHeight(){
                if((((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2) < 200){
                   return (((this.wInnerWidth - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
                }
                return (((this.wInnerHeight - (typeof this.height_correction === 'undefined' ? 0 : this.height_correction)) / 5) * 2);
            },            
            refreshChart(object){
                this.chart.data.labels = object.data.labels;
                let i = 0;
                this.chart.data.datasets.forEach((dataset) => {
                   dataset.data = object.data.datasets[i].data;
                   i++;
                });
                this.chart.options = object.options;
                this.chart.update();
            },
            getArrivalData(param){
                return this.$axios
                    .post("ares/json/ares/syst/dashboard/getYearlyArrivalsv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getYearlyArrivals"
                    },
                    getYearlyArrivals: {
                        year: param,
                    }
                });
            },
            load(param){

                var Year0 = new Date().getFullYear();
                var Year1 = Year0 - 1;
                var Year2 = Year0 - 2;
                var Year3 = Year0 + 1;

                const promise1 = this.getArrivalData(Year0);
                const promise2 = this.getArrivalData(Year1);
                const promise3 = this.getArrivalData(Year2);
                const promise4 = this.getArrivalData(Year3);

                Promise.all([promise1, promise2, promise3, promise4]).then(res => {
                    if(param ==='load'){
                        const ctx = this.$el.querySelector('#arrivals-year').getContext('2d');
                        this.chart = new Chart(ctx, this.createBarData(res[0].data.getYearlyArrivals, 
                                                                       res[1].data.getYearlyArrivals,
                                                                       res[2].data.getYearlyArrivals,
                                                                       res[3].data.getYearlyArrivals));                             
                    } else {
                        this.refreshChart(this.createBarData(res[0].data.getYearlyArrivals, 
                                                             res[1].data.getYearlyArrivals,
                                                             res[2].data.getYearlyArrivals,
                                                             res[3].data.getYearlyArrivals));
                    }
                });
            },             
        }
    }
</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
</style>